import { doc } from "firebase/firestore";
import { FIRESTORE_COLLECTIONS } from "./constants";
import { collection } from "firebase/firestore";

export const getOrganizationDocRef = (db, organizationId) =>
  doc(db, FIRESTORE_COLLECTIONS.ORGANIZATIONS, organizationId);

export const getOrganizationsCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.ORGANIZATIONS);

export const getVesselDocRef = (db, vesselId) =>
  doc(db, FIRESTORE_COLLECTIONS.VESSELS, vesselId);

export const getVesselsCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.VESSELS);

export const getVesselParticularsDocRef = (db, vesselId) =>
  doc(db, FIRESTORE_COLLECTIONS.VESSEL_PARTICULARS, vesselId);

export const getVesselParticularsCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.VESSEL_PARTICULARS);

export const getTankDocRef = (db, tankId) =>
  doc(db, FIRESTORE_COLLECTIONS.TANKS, tankId);

export const getTanksCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.TANKS);

export const getVoyageDocRef = (db, voyageId) =>
  doc(db, FIRESTORE_COLLECTIONS.VOYAGES, voyageId);

export const getVoyagesCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.VOYAGES);

export const getTripDocRef = (db, tripId) =>
  doc(db, FIRESTORE_COLLECTIONS.TRIPS, tripId);

export const getTripsCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.TRIPS);

export const getTripCargoDocRef = (db, cargoId) =>
  doc(db, FIRESTORE_COLLECTIONS.CARGOS, cargoId);

export const getTripCargoCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.CARGOS);

export const getAuditEntryDocRef = (db, auditEntryId) =>
  doc(db, FIRESTORE_COLLECTIONS.AUDIT_ENTRIES, auditEntryId);

export const getAuditEntriesCollectionRef = (db) =>
  collection(db, FIRESTORE_COLLECTIONS.AUDIT_ENTRIES);
